<app-dialog-header [title]="'Confirmação de Cancelamento de Evento'"></app-dialog-header>

<mat-dialog-content>
  <div class="cancel-event-dialog">
    @if (isFreeEvent) {
      <p class="cancel-event-dialog__warning">
        <strong>Atenção, Produtor:</strong><br />
        Este evento é gratuito. O cancelamento é irreversível e não gera reembolso nem multa.
      </p>

      <p class="cancel-event-dialog__question">Você realmente deseja cancelar este evento?</p>
    } @else {
      <p class="cancel-event-dialog__warning">
        <strong>Atenção, Produtor:</strong><br />
        Leia e aceite o termo antes de cancelar. O cancelamento é imediato.
      </p>

      <ul class="cancel-event-dialog__terms">
        <li><strong>Irreversível:</strong> o cancelamento do evento não pode ser desfeito.</li>
        <li>
          <strong>Multa:</strong> será aplicada multa de 10% sobre o valor total das vendas realizadas.
        </li>
        <li>
          <strong>Reembolso:</strong> os compradores terão direito ao reembolso integral.
        </li>
      </ul>

      <label class="cancel-event-dialog__accept">
        <input type="checkbox" [checked]="acceptedTerms" (change)="acceptedTerms = $any($event.target).checked" />
        Li e aceito os termos do cancelamento.
      </label>

      <p class="cancel-event-dialog__question">
        Você realmente está de acordo com o cancelamento deste evento e com os termos acima?
      </p>
    }

    <!--
      TODO: confirmar se a justificativa será utilizada no cancelamento.
      O endpoint POST /events/:id/cancel ainda não recebe o motivo.

      <p>
        Ao prosseguir, você declara estar ciente das cláusulas contratuais aplicáveis. A solicitação será enviada para
        análise da administração antes que o evento seja oficialmente cancelado.
      </p>

      <div class="col">
        <div class="form-group">
          <label class="form-label" for="justificativa">Justificativa</label>
          <div>
            <textarea
              placeholder="Detalhe aqui"
              class="form-control"
              id="justificativa"
              [formControl]="justificativaCtrl"
              [class.is-invalid]="justificativaCtrl.invalid && justificativaCtrl.touched"
              rows="3"></textarea>

            @if (justificativaCtrl.touched && justificativaCtrl.hasError("required")) {
              <div class="text-danger">Esse campo é obrigatório.</div>
            }
          </div>
        </div>
      </div>
    -->
  </div>
</mat-dialog-content>

<mat-dialog-actions align="end" class="gap-2">
  <app-button styleType="outlined" [disabled]="loading" (btnClick)="dialogRef.close()">Não, Voltar</app-button>
  <app-button styleType="danger" [loading]="loading" [disabled]="!canConfirm" (btnClick)="confirm()">
    Sim, Estou de Acordo
  </app-button>
</mat-dialog-actions>
